import React, {Component} from 'react';
import {connect} from 'react-redux';
import ConfirmationTooltip from './confirmation-tooltip';
import TeamExpression from './team-expression';

class Team extends Component {
    onClick(team) {
        const {clickOnTeamCallback} = this.props;
        if (typeof clickOnTeamCallback === 'function') {
            clickOnTeamCallback(team);
        }
    }

    isActive() {
        const {teamName, playersFilter} = this.props;

        return inArray(teamName, playersFilter.games);
    }

    render() {
        let {teamName, className = '', isLeftSide} = this.props;

        if (this.isActive()) {
            className += ' active';
        }

        return (
            <button
                type="button"
                key={teamName}
                onClick={() => ::this.onClick(teamName)}
                className={className}
                ref={teamName}
            >
                <div className="team">
                    {isLeftSide ? <TeamExpression teamName={teamName} /> : null}
                    <ConfirmationTooltip teamName={teamName} />
                    {!isLeftSide ? <TeamExpression teamName={teamName} /> : null}
                </div>
                {this.props.children}
            </button>
        );
    }
}

function mapStatesToProps(state) {
    const {playersData} = state;
    return {
        playersFilter: playersData.filters,
    };
}

const TeamComponent = connect(mapStatesToProps)(Team);

export {TeamComponent};
